export default __webpack_public_path__ + "assets/a5.96cde40a.jpg";